<template>
  <div class="table-container">
    <div class="table-wrapper">
      <MDBTable aria-describedby="reportTable">
        <thead v-if="!isLoading && reports.length > 0">
          <tr>
            <th scope="col">NAME</th>
            <th scope="col" v-for="(date, index) in reportsHeaders" :key="index">{{ formatDate(date) }}</th>
            <th scope="col">TOTAL WORKING HOURS</th>
          </tr>
        </thead>
        <div v-if="isLoading" class="table-empty-container">
          <div class="loading-container" id="table-loader">
            <MDBLoading parentSelector=".table-empty-container" loadingText="" backdropColor="white" :backdropOpacity="0" />
          </div>
        </div>
        <template v-else-if="reports.length < 1">
          <div class="table-empty-container">
            <img src="@/assets/images/2024/empty-table.png" alt="empty-table" />
            <div>
              <h3>There are no employees to show on your end.</h3>
              Start off by selecting a project and other details from the right pane.
            </div>
          </div>
        </template>
        <tbody v-else-if="reports.length > 0">
          <tr v-for="(d, index) in reports" :key="index">
            <td>
              <div class="emp-column text-truncate">
                <label class="text-truncate"> {{ `${d.lastName}, ${d.firstName}` }} </label>{{ d.employeeIdNo }}
              </div>
            </td>
            <td v-for="(ts, index) in d.timeSpent" :key="index">{{ ts.formattedTime }}</td>
            <td>{{ d.formattedTotalTimeSpent }}</td>
          </tr>
        </tbody>
      </MDBTable>
    </div>
    <SPAPagination
      class="pagination"
      textPerPage="Items per page"
      :pagination="reportsPagination"
      @changePage="changePage"
      :reverseOrder="isMediaXS"
      :hideTextPerPage="isMediaXS"
      :minimalItemRange="isMediaXS"
      :minimalPageNumber="isMediaXS"
    />
  </div>
</template>

<script>
import { MDBTable, MDBLoading } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import SPAPagination from '../../../../../components/SPAPagination.vue';
import { useProjectTaggingStore } from '../../../../../stores/projectTagging';
import { onUnmounted, watch } from 'vue';
import { parseDateShort } from '../../../../../helpers/dateParser';
export default {
  components: {
    MDBTable,
    MDBLoading,
    SPAPagination,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const { reports, reportsPagination, reportsHeaders, isLoading } = storeToRefs(projectTagging);
    const getHeaders = (data) => {
      reportsHeaders.value = data.timeSpent?.map((d) => d.date);
    };
    const formatDate = (date) => {
      return parseDateShort(date);
    };

    watch(reports, (newStatus) => {
      if (newStatus.length > 0) {
        getHeaders(reports.value[0]);
      }
    });

    const changePage = async (paginate) => {
      const params = {
        PageNumber: paginate.currentPage,
        RowsPerPage: paginate.itemsPerPage,
      };
      await projectTagging.getProjectLogs(params);
    };
    onUnmounted(() => {
      reports.value = [];
      reportsHeaders.value = [];
      reportsPagination.value = { currentPage: 1, totalPages: 0, totalItems: 0, itemsPerPage: 10 };
    });

    return {
      reports,
      reportsPagination,
      reportsHeaders,
      formatDate,
      changePage,
      isLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/sass/announcement-module.scss' as *;
.pagination {
  border-top: 1px solid $neutral-20;
}
.table-empty-container {
  h3 {
    font-weight: 500;
    font-size: 28px !important;
    height: unset !important;
    max-width: unset !important;
  }
}
.table-empty-container,
.loading-container {
  min-height: 595px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
:deep(.loading-spinner) {
  z-index: unset;
  color: #879a94;
  & .spinner-border {
    width: 120px;
    height: 120px;
    border-width: 10px;
  }
}
:deep(#reportsTable.table) > :not(caption) > * > * {
  padding: 0;
}
.table-wrapper {
  overflow-x: auto;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto, 1fr);
  grid-template-rows: auto;
  border-radius: 8px;
}
table {
  display: block;
  min-width: 100%;
  border-collapse: collapse;
}
#ProjectTaggingMainReport .table-container .table > :not(caption) > * > * {
  padding: 4px 16px;
}
th {
  text-transform: uppercase;
}
thead,
tbody,
tfoot,
tr,
td,
th {
  width: 100%;
}
th:first-child,
td:first-child {
  position: sticky;
  left: 0;
  min-width: 300px;
  max-width: 300px !important;
  background-color: $neutral-0;
}
th:last-child,
td:last-child {
  position: sticky;
  right: 0;
  max-width: 184px !important;
  min-width: 170px;
  background-color: $neutral-0;
}
td:not(:first-child):not(:last-child) {
  width: calc((100% - 368px)) !important;
}
th,
td {
  padding: 8px;
  white-space: nowrap;
}
.emp-column {
  color: $neutral-90;
  display: grid;
  label {
    color: $neutral-800;
  }
}
</style>
